// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const WellKnownProtobufType = {
    any: () => {
        return {
            type: "any",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    api: () => {
        return {
            type: "api",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    boolValue: () => {
        return {
            type: "boolValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    bytesValue: () => {
        return {
            type: "bytesValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    doubleValue: () => {
        return {
            type: "doubleValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    duration: () => {
        return {
            type: "duration",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    empty: () => {
        return {
            type: "empty",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    enum: () => {
        return {
            type: "enum",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    enumValue: () => {
        return {
            type: "enumValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    field: () => {
        return {
            type: "field",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    fieldCardinality: () => {
        return {
            type: "fieldCardinality",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    fieldKind: () => {
        return {
            type: "fieldKind",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    fieldMask: () => {
        return {
            type: "fieldMask",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    floatValue: () => {
        return {
            type: "floatValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    int32Value: () => {
        return {
            type: "int32Value",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    int64Value: () => {
        return {
            type: "int64Value",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    listValue: () => {
        return {
            type: "listValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    method: () => {
        return {
            type: "method",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    mixin: () => {
        return {
            type: "mixin",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    nullValue: () => {
        return {
            type: "nullValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    option: () => {
        return {
            type: "option",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    sourceContext: () => {
        return {
            type: "sourceContext",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    stringValue: () => {
        return {
            type: "stringValue",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    struct: () => {
        return {
            type: "struct",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    syntax: () => {
        return {
            type: "syntax",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    timestamp: () => {
        return {
            type: "timestamp",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    type: () => {
        return {
            type: "type",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    uint32Value: () => {
        return {
            type: "uint32Value",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    uint64Value: () => {
        return {
            type: "uint64Value",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    value: () => {
        return {
            type: "value",
            _visit: function (visitor) {
                return FernIr.WellKnownProtobufType._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "any":
                return visitor.any();
            case "api":
                return visitor.api();
            case "boolValue":
                return visitor.boolValue();
            case "bytesValue":
                return visitor.bytesValue();
            case "doubleValue":
                return visitor.doubleValue();
            case "duration":
                return visitor.duration();
            case "empty":
                return visitor.empty();
            case "enum":
                return visitor.enum();
            case "enumValue":
                return visitor.enumValue();
            case "field":
                return visitor.field();
            case "fieldCardinality":
                return visitor.fieldCardinality();
            case "fieldKind":
                return visitor.fieldKind();
            case "fieldMask":
                return visitor.fieldMask();
            case "floatValue":
                return visitor.floatValue();
            case "int32Value":
                return visitor.int32Value();
            case "int64Value":
                return visitor.int64Value();
            case "listValue":
                return visitor.listValue();
            case "method":
                return visitor.method();
            case "mixin":
                return visitor.mixin();
            case "nullValue":
                return visitor.nullValue();
            case "option":
                return visitor.option();
            case "sourceContext":
                return visitor.sourceContext();
            case "stringValue":
                return visitor.stringValue();
            case "struct":
                return visitor.struct();
            case "syntax":
                return visitor.syntax();
            case "timestamp":
                return visitor.timestamp();
            case "type":
                return visitor.type();
            case "uint32Value":
                return visitor.uint32Value();
            case "uint64Value":
                return visitor.uint64Value();
            case "value":
                return visitor.value();
            default:
                return visitor._other(value);
        }
    },
};
